import { updateLocalStorage, prefixedKey } from '@tools/localStorage';
import { get, isEqual } from 'lodash';

/*
  Storage is written on TRANSITIONS of the synced slice, never merely because an action was
  dispatched. Storage is shared between tabs while this state is per-tab: syncing on every action
  meant a tab whose slice was null kept re-asserting that null, so any dispatch in a logged-out tab
  (a LOGIN_PENDING included) deleted the token another tab had just written — and the cross-tab
  logout hook then signed that tab out, silently.

  The initial dispatch (state === undefined) still writes through: that is what cleans a corrupt
  stored value up the first time the store settles, instead of leaving it to break the next boot.
*/
export default (reducer, path, key) => (state, action) => {
  const reducedState = reducer(state, action);
  const stateToPersist = get(reducedState, path);

  if (state === undefined || !isEqual(stateToPersist, get(state, path))) {
    updateLocalStorage({
      [prefixedKey(key)]: stateToPersist
    });
  }

  return reducedState;
};

// import {updateLocalStorage, getLocalStorage, prefixedKey} from '@tools/localStorage';
// import { updateObjectDeepKey } from '@tools/formTools';
// import { get } from 'lodash';

// export default (name, subStatePath = '') => {
//   const storageState = getLocalStorage(prefixedKey(name))
//   return {
//     buildInitialState: defaultInitialState =>
//        updateObjectDeepKey(defaultInitialState, subStatePath.split('.'), storageState),
//     withSyncStorage: (reducer) => (state, action) => {
//       const reducedState = reducer(state, action);
//       updateLocalStorage({
//         [prefixedKey(key)]: get(reducedState, path)
//       });

//       return reducedState;
//     }
//   }
// }
